

































import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import PlanosAba from "../tables/PlanosAba.vue";
import Confirm from "@/shared/components/confirm.vue";
import { ConsultoresService } from "@/services/consultores.service";
import { required, validEmail } from "@/shared/validators";

@Component({
  components: {
    DataTable,
    Confirm,
    PlanosAba,
  },
})
export default class AlterarEmail extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  loading = false;
  senha: string | null = "";
  showSucess?: boolean = false;
  emailConsultor: string | null = "";
  showError?: boolean = false;
  msgEmail: string | null = "";
  canEdit = false;

  rules = {
    email: [required(), validEmail()],
  };

  mounted() {
    this.fetchEmail();
  }

  async fetchEmail() {
    this.loading = true;
    try {
      this.emailConsultor = await ConsultoresService.ObterEmailConsultor(
        this.idConsultor
      );
    } finally {
      this.loading = false;
    }
  }

  async AlterarEmail() {
    const form = this.$refs.form as any;
    if (form.validate()) {
      this.startLoader();
      await ConsultoresService.AlterarEmail(
        this.idConsultor,
        this.emailConsultor!
      ).finally(this.stopLoader);

      this.$emit("emailAtualizado", this.emailConsultor);

      this.msgEmail = "Email alterado com sucesso";
      this.showSucess = true;
      setTimeout(this.fechaAlertaStatus, 5000);
    }
  }

  fechaAlertaStatus() {
    this.showSucess = false;
    this.showError = false;
  }
}
